/**
 * narcisIntakeEvent — adapts `useModelIntake`'s own internal event names
 * (model_intake_photo_verified/_rejected/_photos_ready — fixed in
 * `@core/hooks/useModelIntake.ts`, shared byte-for-byte with ovid) onto the narcis_funnel dictionary
 * (narcis_funnel plan, decision 8: `/model` speaks only the 17-event dictionary). Lifted out of
 * `routes/_layout.model.tsx` (narcis wall plan step 4) so the wall's own mount of `ModelIntake`
 * (`products/narcis/wall/IdentityIntake.tsx`) fires the SAME events through the SAME mapping,
 * rather than a second hand-written copy.
 *
 * intake_photo_added(verdict, reason, n_verified) folds the verified/rejected pair — the hook
 * threads `reason` on a rejection since 2026-08-11. model_intake_photos_ready has no dictionary
 * equivalent and is silently dropped — sound specifically because n_verified rides every add: the moment the set crosses MIN_TRAINING_PHOTOS
 * is just the count at its threshold, so a separate "photos ready" event would only restate what
 * this parameter already carries.
 */
import type {ModelIntakeOnEvent} from '@core/hooks/useModelIntake'
import {narcisTrack} from '@product/narcis/utils/analytics'

export const narcisIntakeEvent: ModelIntakeOnEvent = ((event: string, params: {n_verified: number; reason?: string}) => {
  if (event === 'model_intake_photo_verified') {
    narcisTrack('intake_photo_added', {verdict: 'ok', n_verified: params.n_verified})
  } else if (event === 'model_intake_photo_rejected') {
    narcisTrack('intake_photo_added', {verdict: 'failed', reason: params.reason, n_verified: params.n_verified})
  }
}) as ModelIntakeOnEvent
